import type { HTMLAttributes, ReactNode } from 'react'

import { cn } from '../lib/utils'
import { Flex } from './flex'
import { InfoBox } from './info-box'

interface LayoutLogoProps extends HTMLAttributes<HTMLDivElement> {
    children: ReactNode
    logo?: string
    logoClassName?: string
    className?: string
}

export const LayoutLogo = ({
    children,
    className,
    logo,
    logoClassName,
    ...props
}: LayoutLogoProps) => {
    return (
        <Flex
            className={cn(
                'flex-col items-center flex-1 w-full max-w-[372px] p-4 py-5 self-center sm:max-w-full md:max-w-full',
                className,
            )}
            {...props}
        >
            {logo && (
                <img
                    src={logo}
                    className={cn('w-[126px] h-[37px] mb-6', logoClassName)}
                    alt="Leanpay Logo"
                />
            )}
            <LayoutColumn>{children}</LayoutColumn>
        </Flex>
    )
}

interface LayoutColumnProps {
    children: ReactNode
    className?: string
}

export const LayoutColumn = ({ children, className }: LayoutColumnProps) => {
    return (
        <Flex className={cn('flex-col items-center w-full max-w-[340px]', className)}>
            {children}
        </Flex>
    )
}

interface FormLayoutProps {
    children: ReactNode
    errorMessage?: string | null
    successMessage?: string | null
    warningMessage?: string | null
    className?: string
}

export const FormLayout = (props: FormLayoutProps) => {
    const { warningMessage, successMessage, errorMessage, children, className } = props

    return (
        <LayoutColumn className={className}>
            <Flex className="flex-col w-full">
                {errorMessage && (
                    <InfoBox className="mb-4" infoType="error" message={errorMessage} />
                )}
                {successMessage && (
                    <InfoBox className="mb-4" infoType="success" message={successMessage} />
                )}
                {warningMessage && (
                    <InfoBox className="mb-4" infoType="warning" message={warningMessage} />
                )}
            </Flex>
            {children}
        </LayoutColumn>
    )
}
